import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { DavidN_Video2 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoDavidN2 = () => {
  return (
    <>
      <ModalVideo
        id="david-n-video-2"
        dataText={DavidN_Video2}
        videoSrc="https://www.youtube.com/embed/iJAdVeFWZps?si=96D8E9w3JNnyumKi"
        videoTitle="KUTER_STUDIO_AI_DAVID_N_VIDEO_2"
      />
    </>
  );
};

export default ModalVideoDavidN2;
